import { Injectable, Inject } from '@angular/core';
import { LoginService } from 'app/resources/services/login.service';
import { SaldoService } from 'app/resources/services/saldo.service';
import { PermissionService } from 'app/resources/services/permission.service';
import { HttpService } from 'app/resources/services/http.service';
import { DownloadService } from 'app/resources/services/download.service';
import { SessionService } from 'app/resources/services/session-service.service';
import { CartaoService } from 'app/resources/services/cartao.service';
import { CiService } from 'app/resources/services/ci.service';
import { CssService } from 'app/resources/services/css.service';
import { ServicesService } from 'app/resources/services/services.service';
import { PagamentoService } from 'app/resources/services/pagamento.service';
import { CepService } from 'app/resources/services/cep.service';
import { ValePresenteCestaService } from 'app/resources/services/vale-presente-cesta-service.service';
import { ValePresenteService } from 'app/resources/services/vale-presente.service';
import { ParceiroService } from 'app/resources/services/parceiro.service';
import { LojaService } from 'app/resources/services/loja.service';
import { LojaCarrinhoService } from 'app/resources/services/loja-carrinho.service';
import { SacService } from 'app/resources/services/sac.service';
import { AvisoService } from 'app/resources/services/aviso.service';

@Injectable()
export class MainService {

  constructor(
    public loginService: LoginService,
    public saldoService: SaldoService,
    public permissionService: PermissionService,
    public http: HttpService,
    public downloadService: DownloadService,
    public sessionService: SessionService,
    public cartaoService: CartaoService,
    public ciService: CiService,
    public cssService: CssService,
    public servicesService: ServicesService,
    public pagamentoService: PagamentoService,
    public cepService: CepService,
    public valePresenteCestaService: ValePresenteCestaService,
    public valePresenteService: ValePresenteService,
    public parceiroService: ParceiroService,
    public lojaService: LojaService,
    public lojaCarrinho: LojaCarrinhoService,
    public sacService: SacService,
    public aviso: AvisoService
  ) { }
  clean(): any {
    this.parceiroService.clean();
    this.lojaService.clean();
    this.lojaCarrinho.limpar();
    this.permissionService.clean();
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/services/main.service.ts